export enum AssessmentStatus {
  COMPLETED_LATE = 'COMPLETED_LATE',
  COMPLETED_ON_TIME = 'COMPLETED_ON_TIME',
  COMPLETED_NOT_DUE = 'COMPLETED_NOT_DUE',
  IN_PROGRESS_PAST_DUE = 'IN_PROGRESS_PAST_DUE',
  IN_PROGRESS_DUE = 'IN_PROGRESS_DUE',
  IN_PROGRESS_NOT_DUE = 'IN_PROGRESS_NOT_DUE',
}
